import {
    CanceledPaymentTableRecord,
    HistoricalPaymentTableRecord,
    PaymentTableRecord,
} from '@mews-commander/data-access';
import { Dash, TooltippedTag } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { getTagVariantFromPaymentState, paymentStatusTextKeyMap } from './utils';

interface Props {
    state: CanceledPaymentTableRecord['state'] | PaymentTableRecord['state'] | HistoricalPaymentTableRecord['state'];
    transactionDetails?: PaymentTableRecord['transactionDetails'] | HistoricalPaymentTableRecord['transactionDetails'];
    isOverpayment?: boolean;
}

export const PaymentsTableStatusCell = ({ state, transactionDetails, isOverpayment }: Props) => {
    if (isOverpayment) {
        return (
            <TooltippedTag variant="primary" outline tooltip={lt('OverpaidTooltipMessage')}>
                {lt('Overpaid')}
            </TooltippedTag>
        );
    }

    if (!state) {
        return <Dash />;
    }

    return (
        <TooltippedTag variant={getTagVariantFromPaymentState[state]} tooltip={transactionDetails} outline>
            {lt(paymentStatusTextKeyMap[state])}
        </TooltippedTag>
    );
};
